import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from "@material-ui/core";
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DefaultEmailAndPhoneSettings from "./DefaultEmailAndPhoneSettings";
import Notifications from "./Notifications";
import Reminders from "./Reminders/Reminders";
import OtherSettings from "./OtherSettings/OtherSettings";
import ChangeTiresSchedule from './ChangeTiresSchedule/ChangeTiresSchedule';
import SaveButton from "../Shared/SaveButton";
import MobileAppKey from "./MobileAppKey";
import withSubordinateUser from './../../HOC/withSubordinateUser';
import ActionCreator from './../../../store/actions/index';

const GeneralSettings = (props) => {
    const { nonAdminUser, saveActive, defaultEmailsAndPhones, otherSettings, mobileAppKey, groupOptions, tireChange, trophySettings } = props;
    const [state, setState] = useState(null);

    const handleChange = (name, data) => {
        setState(prevState => ({
            ...prevState,
            [name]: data
        }));
    };



    return (
        <Grid container>
            <Grid item xs={12}>
                <DefaultEmailAndPhoneSettings
                    data={defaultEmailsAndPhones}
                    onChange={(data) => handleChange("defaultEmailsAndPhones", data)}
                    onContentChanged={(value) => props.changeSaveReadiness("defaultEmailsAndPhones", value)}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Notifications
                    onChange={(data) => handleChange("notifications", data)}
                    onContentChanged={(value) => props.changeSaveReadiness("notifications", value)}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Reminders
                    onChange={(data) => handleChange("reminders", data)}
                    onContentChanged={(value) => props.changeSaveReadiness("reminders", value)}
                />
            </Grid>
            {
                !nonAdminUser
                &&
                <Grid item xs={12} md={6}>
                    <OtherSettings
                        data={otherSettings}
                        onChange={(data) => handleChange("otherSettings", data)}
                        onContentChanged={(value) => props.changeSaveReadiness("otherSettings", value)}
                        trophySettings={trophySettings.trofea}
                        onConfirmTrophySettings={(value) => props.sendTrophySetting(value)}
                        onExpectedFuelConsumptionSubmit={(data) => props.postExpectedFuelConsumption(data)}
                    />
                </Grid>
            }
            <Grid item xs={12} md={6}>
                {!nonAdminUser &&
                    <ChangeTiresSchedule
                        data={tireChange}
                        onChange={(data) => handleChange("tireChange", data)}
                        onContentChanged={(value) => props.changeSaveReadiness("tireChange", value)}
                    />
                }
                <MobileAppKey
                    data={mobileAppKey}
                    groupOptions={groupOptions}
                    onNewKeyRequest={(newGroupId) => props.putSettingsMobileKey(newGroupId)}
                />
            </Grid>
            {
                // different display in case of non admin user
                nonAdminUser
                &&
                <Grid item xs={12} md={6}>
                    <ChangeTiresSchedule
                        data={tireChange}
                        onChange={(data) => handleChange("tireChange", data)}
                        onContentChanged={(value) => props.changeSaveReadiness("tireChange", value)}
                    />
                </Grid>
            }
            <SaveButton
                visible={Boolean(saveActive)}
                onClick={() => props.sendChangedData(state)}
            />
        </Grid>
    );
};

const mapStateToProps = (state) => ({
    saveActive: Object.values(state.settingsReducer.readyToSave).includes(true),
    defaultEmailsAndPhones: state.settingsReducer.defaultEmailsAndPhones,
    otherSettings: state.settingsReducer.otherSettings,
    tireChange: state.settingsReducer.tireChange,
    mobileAppKey: state.settingsReducer.mobileAppKey,
    trophySettings: state.settingsReducer.trophySettings,
    groupOptions: state.filterReducer.groupOptions,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


GeneralSettings.propTypes = {
    //withSubordinateUser
    nonAdminUser: PropTypes.bool,
    //redux
    saveActive: PropTypes.bool,
    defaultEmailsAndPhones: PropTypes.object,
    otherSettings: PropTypes.object,
    mobileAppKey: PropTypes.object,
    groupOptions: PropTypes.array,
    trophySettings: PropTypes.object,
    tireChange: PropTypes.object,
    changeSaveReadiness: PropTypes.func,
    putSettingsMobileKey: PropTypes.func,
    sendChangedData: PropTypes.func,
    sendTrophySetting: PropTypes.func,
    postExpectedFuelConsumption: PropTypes.func,

};

export default compose(
    withSubordinateUser,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(GeneralSettings);
